import { Component, OnInit } from '@angular/core';
import { CreateRoomComponent } from './pages/create-room/create-room.component';
import {MatDialog} from '@angular/material/dialog';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError, ActivatedRoute} from '@angular/router';
import { AuthService } from './_services/auth.service';
import { User } from './_core/_interface/user';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'spirikal';
  openedMeeting = false;
  user: User;
  sehelProjId: string = '';

  constructor(public router: Router, public dialog: MatDialog, private auth: AuthService, private route: ActivatedRoute,) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
          // Show progress spinner or progress bar
      }

      if (event instanceof NavigationEnd) {
          // Hide progress spinner or progress bar
          if (event.url?.indexOf('/jitsi') > -1) {
            this.openedMeeting = true;
          }
      }

      if (event instanceof NavigationError) {
           // Hide progress spinner or progress bar

          // Present error to user
          console.log(event.error);
      }
  });
  }

  async  ngOnInit() {
    // await this.deleteAllDatabases();
    if(this.auth.currentUserValue) {
      this.user = this.auth.currentUserValue;
    } 
    this.auth.handleRedirect();
  }

  async deleteAllDatabases() {
    const databases = await indexedDB.databases();
    for (const db of databases) {
      if (db.name) {
        await indexedDB.deleteDatabase(db.name);
        console.log(`База данных "${db.name}" успешно удалена.`);
      }
    }
  }

  openDialog() {
    this.openedMeeting = true;
    const dialogRef = this.dialog.open(CreateRoomComponent);
    dialogRef.afterClosed().subscribe(result => {
      this.openedMeeting = false;
    });
  }
}
